import { GetStaticProps, NextPage } from 'next';
import { Container, Row, Col } from 'reactstrap';
import { RichText } from 'prismic-reactjs';
import { Client } from '../utils';
import { Section } from '../components/Sections';
import { Article } from '../components/Article';
import { Layout, SeoMeta } from '../components/Layout';
interface Articles {
  content: any;
  articles: Array<Article>;
}
interface Article {
  article__headline: any;
  article__text: any;
  article__link: {
    link_type: string;
    url: string;
  };
  article__image: {
    dimensions: {
      width: number;
      height: number;
    };
    alt: string;
    copyright: string;
    url: string;
  };
}

const Press: NextPage<Articles> = ({ content, articles }) => {
  return (
    <Layout>
      <SeoMeta
        title={RichText.asText(content.seo__title)}
        desc={RichText.asText(content.seo__description)}
        socialImage={content.seo__image}
      />
      <Section hasTop={false}>
        <Container fluid>
          <Row>
            {articles.length === 0 && (
              <h1 className="font--primary font--xl m-t">No articles found</h1>
            )}

            {articles.length !== 0 &&
              articles.map((article, key) => {
                return (
                  <Col
                    xs={{ size: 6 }}
                    sm={{ size: 4 }}
                    lg={{ size: 3 }}
                    key={key}
                  >
                    <Article
                      headline={
                        RichText.asText(article.article__headline) || '-'
                      }
                      text={RichText.asText(article.article__text) || '-'}
                      url={article.article__link.url || '#'}
                      image={{
                        src: article.article__image.url,
                        alt: article.article__image.alt,
                        width: article.article__image.dimensions.width,
                        height: article.article__image.dimensions.height,
                      }}
                    />
                  </Col>
                );
              })}
          </Row>
        </Container>
      </Section>
    </Layout>
  );
};

export const getStaticProps: GetStaticProps = async () => {
  // https://prismic.io/docs/technologies/query-by-type-rest-api
  const res = await Client.query('[at(document.type, "press")]');
  const data = res.results.map((content: { data: any }) => {
    return content.data;
  });
  const content = data[0];
  const articles = data[0].articles;

  articles.sort();

  return {
    props: {
      content,
      articles,
    },
  };
};

export default Press;
